import styled, { css as styledCSS } from "styled-components";

import type { BreadcrumbLinkProps } from "./Link";

export const breadcrumbLinkStyles = styledCSS<BreadcrumbLinkProps>`
  font-family: "Open Sans", Helvetica, Arial, sans-serif;
  text-decoration: none;
  font-size: var(--fs-xxs, 12px);
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  border-radius: 2px;
  padding: 8px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  color: ${props =>
    props.$isActive
      ? "var(--mode-text-primary-default)"
      : "var(--mode-overrides-header-text-weak)"};

  &:hover {
    border-radius: var(--theme-br-default, 8px);
    ${props =>
      !props.$isActive &&
      styledCSS`
        background-color: var(--mode-bg-neutral-inverse-weak);
        color: var(--mode-text-neutral-inverse-weak);
      `}
  }
`;
export const BreadCrumbLink = styled.a<BreadcrumbLinkProps>`
  ${breadcrumbLinkStyles}
`;
